
export default {
    en : require('./en').default,
}



// WEBPACK FOOTER //
// ./lang/index.js